import { Component, OnInit, Input } from '@angular/core';
import { ApiService } from 'app/services/api.service';
import { PronunciationService, Pronunciation } from '../../services/pronunciation.service';

@Component({
  selector: 'app-display-matching-pronunciatons',
  templateUrl: './display-matching-pronunciatons.component.html',
  styleUrls: ['./display-matching-pronunciatons.component.css']
})
export class DisplayMatchingPronunciatonsComponent implements OnInit {

  public entities: Pronunciation[];

  @Input() psalterId: number;
  @Input() lectionaryItemId: number;

  constructor(
      public apiSvc: ApiService,
      public pronunciationSvc: PronunciationService
      ) { }

  ngOnInit(): void {
    console.log(this.psalterId, this.lectionaryItemId);

    this.getItems().then((data) => {
      this.entities = data;
    })
  }


  public getItems(): Promise<Pronunciation[]> {

    const p = new Promise<Pronunciation[]>((resolve, reject) => {

      var url = ""; 
      if (this.psalterId != null) {
        url = "api/pronunciation/psalter/" + this.psalterId;
      } 
      else if (this.lectionaryItemId != null) {
        url = "api/pronunciation/lectionaryItem/" + this.lectionaryItemId;
      }

      this.apiSvc.get(url, null).subscribe(
        (data: Pronunciation[]) => {
          console.log(url, data);
          resolve(data);
        },
        (err) => {
          console.log("error", err);
        }
      );

    });

    return p;
  }

}
 